import {
    Component,
    Input,
    Output,
    ElementRef,
    OnInit,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';

import {ProductGroup, AlternativeSelectedEvent} from "../model/product.group";
import {Product} from "../model/product";
import {EventsService} from "../services/events.service";
import {Logger} from "../utils/logger";
import {CONFIG} from "../config";

@Component({
    selector: 'subproduct-alternative',
    templateUrl: "./subproduct_alternative.component.html"
})

export class SubProductAlternativeComponent implements AfterViewInit, OnChanges, OnInit {
    @Input("group")
    public productGroup;

    @Input()
    public action;

    @Input()
    public tabName;

    @Input()
    public alternative;

    @Input()
    public product;

    @Input()
    public alternativeIndex;

    @Input()
    public tabContent;

    public isLoadingShow = false;

    @Output('onAlternativeSelected')
    public alternativeSelected: EventEmitter<AlternativeSelectedEvent>;

    constructor(public el: ElementRef, public eventBus: EventsService, public logger: Logger) {
        this.alternativeSelected = new EventEmitter<AlternativeSelectedEvent>();
    }

    ngOnChanges(changes: any): any {

    }


    ngOnInit(): void {
        this.eventBus.on("products.renderImageLoaded", this.onProductImageLoaded, this);
    }

    ngAfterViewInit(): any {
        if (this.alternative) {
            let img = this.el.nativeElement.querySelector('.product-img');

            img.addEventListener('load', () => {
                $(img).animate({opacity: 1}, 500);
            });

            img.src = this.productGroup.getAlternativesIcons()[this.alternativeIndex];
        }

    }

    onProductImageLoaded() {
       // debugger;
        this.isLoadingShow = false;
    }

    public showAltSpinner() {
        this.isLoadingShow = true;
    }

    onSelected(event: Event, altNumber: number, productGroup: ProductGroup, product: Product) {
        this.showAltSpinner();
        this.alternativeSelected.emit({productGroup: productGroup, altNumber: altNumber, product: product});
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/subproduct_alternative.component.ts